import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {CookieService} from 'ngx-cookie-service';
import * as _ from "lodash";
import {environment} from "../../environments/environment";


@Injectable({
   providedIn: 'root'
})
export class ServerService {

   public static instance:ServerService;

   constructor(public http:HttpClient,
               public cookieSrv: CookieService) {
      ServerService.instance = this;
   }


   private onSuccess(resolve:any, res:any, Class:any=null, many=false, dx=false){
      let ris = res
      if(!dx){
         if(!isNaN(res?.data) || res.data)
            ris = res.data
         if(Class){
            if(many) resolve(_.map(ris, (d: any) => { return new Class(d); }));
            else resolve(new Class(ris));
         }
         else resolve(ris)
      }else{
         resolve(ris)
      }
   }

   private onError(reject:any, err:any){
      console.error("[onError]");
      console.log(err)
      if(err.status === 0)
         return reject("Impossibile contattare il server, controllare la connessione e riprovare");

      if(_.isString(err.error?.data))
         return reject(err.error.data);

      if(err && err.error && err.error.message)
         return reject(err.error.message);

      reject(err);
   }

   private getHeader(isFile=false){

      let headers:any = null;
      if(!isFile){
         headers = new HttpHeaders({'Content-Type':  'application/json'})
      }else{
         headers = new HttpHeaders({})
      }

      // TOKEN di django
      let csrf = this.cookieSrv.get("csrftoken")
      headers = headers.set('X-CSRFToken', csrf)
      headers = headers.set('csrftoken', csrf)

      // session
      let sessionid = this.cookieSrv.get("sessionid")
      if(sessionid){
         headers = headers.set('sessionid', sessionid)
      }

      return {
         headers:headers,
         params:null
      };
   }

   public get(Class:any, url:string, data= {}):Promise<any>{
      url = environment.urlServer + url;
      console.log("[CALL] GET " + url);
      let opt:any = this.getHeader();
      opt["params"] = data;
      return new Promise((resolve, reject) => {
         this.http.get(url, opt).subscribe(
            (res:any) => this.onSuccess(resolve, res, Class),
            error => this.onError(reject, error)
         )})
   }

   public getAll(Class:any, url:string, data= {}, dx=false):Promise<any[]>{
      url = environment.urlServer + url;
      console.log("[CALL] GET " + url);
      let opt:any = this.getHeader();
      opt["params"] = data;
      return new Promise((resolve, reject) => {
         this.http.get(url, opt).subscribe(
            (res:any) => this.onSuccess(resolve, res, Class, true, dx),
            error  => this.onError(reject, error)
         )})
   }

   public post(url:string, data= {}, Class: any=null):Promise<any>{
      url = environment.urlServer + url;
      console.log("[CALL] POST " + url);
      let opt:any = this.getHeader();
      return new Promise((resolve, reject) => {
         this.http.post(url, data, opt).subscribe(
            (res:any) => this.onSuccess(resolve, res, Class),
            error  => this.onError(reject, error)
         )})
   }

   public put(url:string, data= {}, Class: any=null):Promise<any>{
      url = environment.urlServer + url;
      console.log("[CALL] PUT " + url);
      let opt:any = this.getHeader();
      return new Promise((resolve, reject) => {
         this.http.put(url, data, opt).subscribe(
            (res:any) => this.onSuccess(resolve, res, Class),
            error  => this.onError(reject, error)
         )})
   }

   public delete(url:string, data= {}, Class: any=null):Promise<any>{
      url = environment.urlServer + url;
      console.log("[CALL] PUT " + url);
      let opt:any = this.getHeader();
      opt["params"] = data;
      return new Promise((resolve, reject) => {
         this.http.delete(url, opt).subscribe(
            (res:any) => this.onSuccess(resolve, res, Class),
            error  => this.onError(reject, error)
         )})
   }

   public putAll(url:string, data= {}, Class: any=null):Promise<any[]>{
      url = environment.urlServer + url;
      console.log("[CALL] PUT " + url);
      let opt:any = this.getHeader();
      return new Promise((resolve, reject) => {
         this.http.put(url, data, opt).subscribe(
            (res:any) => this.onSuccess(resolve, res, Class, true),
            error  => this.onError(reject, error)
         )})
   }

   public uploadFile(url:string, files:{name:string, file:File}[] = [], data:any= {}, method: 'post' | 'put' = 'post', Class: any=null, append_data=false, downloadFile=false){
      url = environment.urlServer + url;

      let opt:any = this.getHeader(true);
      const formData = new FormData();

      for(let f of files){
         formData.append(f.name, f.file);
      }

      if (append_data)
         formData.append('data', data)
      else{
         for(let k in data){
            formData.append(k, data[k]);
         }
      }

      if (downloadFile){
         return new Promise((resolve, reject) => {
            opt['responseType'] = 'blob' as 'json'
            console.log(opt)
            this.http.post(url, formData, opt).subscribe(
               (data:any) => {
                  const blob = new Blob([data], { type: 'application/octet-stream' });                  console.log(blob)
                  resolve(blob)
               },
               (err)  => {
                  console.log(err)
                  this.onError(reject, err)
               })
         })
      }else {
         return new Promise((resolve, reject) => {
            if (method == 'post'){
               this.http.post(url, formData, opt).subscribe(
                  (res:any) => this.onSuccess(resolve, res, Class),
                  error  => this.onError(reject, error)
               )
            }
            else {
               this.http.put(url, formData, opt).subscribe(
                  (res:any) => this.onSuccess(resolve, res, Class),
                  error  => this.onError(reject, error)
               )
            }
         })
      }


   }


   public getPrivateMedia(media_url){
      return `${environment.urlServer}/media_private/${media_url}`;
   }

   public async logout(){
      return new Promise((resolve, reject) => {
         this.post("/auth/logout").then(res=>{
            console.log("OK logout");
            this.cookieSrv.delete("csrftoken");
            localStorage.clear();
            window.location.replace(environment.loginPath)
            resolve(null)
         }).catch(reason => {
            console.log("ERRORE")
            console.error(reason)
            reject(reason)
         })
      })
   }

   public postAndDownloadPdf(url:string, data= {}, Class: any=null):Promise<any>{
      url = environment.urlServer + url;
      console.log("[CALL] POST " + url);
      let opt:any = this.getHeader();
      opt['responseType'] = 'blob'
      console.log(opt)
      return new Promise((resolve, reject) => {
         this.http.post(url, data, opt).subscribe(
            (res:any) => {
               const url = window.URL.createObjectURL(res);
               // Crea un anchor element per il download del PDF

               window.open(url, '_blank');

               // const anchor = document.createElement('a');
               // anchor.href = url;
               // anchor.download = 'file.pdf';
               // anchor.click();

               // Rilascia l'URL oggetto
               window.URL.revokeObjectURL(url);
               resolve(true)
            },
            error  => this.onError(reject, error)
         )})
   }


   public downloadFile(Class:any, url:string, data= {}, dx=false, method:string='get'):Promise<any>{

      if(!url.startsWith("http") && !url.startsWith(environment.urlServer))
         url = environment.urlServer + url;

      console.log("[CALL] GET " + url);
      let opt:any = this.getHeader();
      opt["params"] = data;
      if (method == 'get'){
         return new Promise((resolve, reject) => {
            this.http.get(url, { responseType: 'blob' }).subscribe(
               (data:Blob) => {
                  console.log(data)
                  resolve(data)
               },
               (error:any) =>{
                  console.log(error)
                  this.onError(reject, error)
               }
            )
         })
      }else {
         return new Promise((resolve, reject) => {
            opt['ResponseType'] = 'blob'
            console.log(opt)
            this.http.post(url, data, opt).subscribe(
               (data:any):any => {
                  const blob = new Blob([data], { type: 'application/octet-stream' });
                  console.log(blob)
                  resolve(blob)
               },
               (err)  => {
                  console.log(err)
                  this.onError(reject, err)
               }
            )}
         )
      }
   }

}
